import { Component } from 'react';
import DisplayedCardContainer from './DisplayedCardContainer';
import FilterPill from '../../customize/components/FilterPill';
import { connect } from 'react-redux';
import {
  getFilteredSkus,
  getCategories,
  selectSkuCategory,
  toggleSkuFilter,
  applySkuFilters,
  clearSkuFilters,
  updateSearchText,
  changeSorting,
} from '../../customize/actions_creators';

class GroceriesRoute extends Component {
  componentDidMount() {
    // if there are skus in the state don't fetch
    // sendPageView()
    if (!this.props.skus.length) {
      this.props.getFilteredSkus();
    }

    // if Customer lands on this page and there are no dishtypes
    if (!this.props.categories.length) {
      this.props.getCategories();
    }
  }

  render() {
    let {
      selectedSkuCategory,
      appliedSkuFilters,
      toggleSkuFilter,
      applySkuFilters,
      clearSkuFilters,
      updateSearchText,
      skus,
      categories,
      getFilteredSkus,
      canLoadMoreSkus,
      totalCount,
      appliedSearchText,
      changeSorting,
      sorting,
      error,
      tagOptions,
    } = this.props;

    const clearFunc = () => {
      updateSearchText('');
      clearSkuFilters();
      getFilteredSkus();
    };

    return (
      <div className="groceries-route">
        <DisplayedCardContainer
          isRecipe={false}
          items={skus}
          loadMoreFunc={getFilteredSkus}
          hasMore={canLoadMoreSkus}
          clearFunc={clearFunc}
          appliedFilters={appliedSkuFilters}
          totalCount={totalCount}
          appliedSearchText={appliedSearchText}
          changeSorting={changeSorting}
          sorting={sorting}
        >
          <FilterPill
            appliedFilters={appliedSkuFilters}
            toggleFunc={toggleSkuFilter}
            applyFunc={applySkuFilters}
            getFunc={getFilteredSkus}
            isRecipe={false}
            appliedSearchText={appliedSearchText}
            updateTextFunc={updateSearchText}
            isCustomize={false}
            tagOptions={tagOptions}
          />
        </DisplayedCardContainer>
        {/* <SideBar type="filters">
          <div className="hr-title-md">Filters Groceries</div>
          <GroceriesFilters />
        </SideBar> */}
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    skus: state.filters.skus,
    appliedSkuFilters: state.filters.appliedSkuFilters,
    selectedSkuCategory: state.filters.selectedSkuCategory,
    categories: state.featured.categories,
    canLoadMoreSkus: state.filters.canLoadMoreSkus,
    skusTotalCount: state.filters.skusTotalCount,
    categoryCount: state.filters.categoryCount,
    totalCount: state.filters.skusTotalCount,
    appliedSearchText: state.filters.appliedSearchText,
    sorting: state.filters.sorting,
    error: state.filters.error,
    tagOptions: state.filters.tagOptions,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {
    getFilteredSkus: (loadMore) => dispatch(getFilteredSkus(loadMore)),
    toggleSkuFilter: (filter, filterCategory) =>
      dispatch(toggleSkuFilter(filter, filterCategory)),
    applySkuFilters: () => dispatch(applySkuFilters()),
    selectSkuCategory: (category) => dispatch(selectSkuCategory(category)),
    getCategories: () => dispatch(getCategories()),
    clearSkuFilters: () => dispatch(clearSkuFilters()),
    updateSearchText: (text) => dispatch(updateSearchText(text)),
    changeSorting: (sorting) => dispatch(changeSorting(sorting)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroceriesRoute);
